{
  "close": "סגור",
  "notifications": "{count, plural, one {# התראה} other {# התראות}}."
}
